import { useContext } from 'react';

import PropertiesDataContext from 'common/contexts/PropertiesData/PropertiesDataContext';

const usePropertiesData = () => useContext(PropertiesDataContext);

export default usePropertiesData;
